/** @format */

import { request } from '@power/runtime-vue3';
import * as V1 from '@/api/version-v1';

// 获取字典分类列表
export async function getDictTypes(typeKey) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return await V1.useDictTypeList();
	}
	const res = await request<
		{
			name: string;
			typeKey: string;
		}[]
	>({
		url: '/base/system/sysCatType/findChildrenByTypeKey',
		method: 'get',
		params: {
			typeKey,
		},
	});
	const resp: {
		label: string;
		value: string;
	}[] = res.map((p) => ({
		label: p.name,
		value: p.typeKey,
		...p,
	}));
	return resp;
}

// 根据字典类型查询字典数据信息
export async function getDicts(typeKey) {
	const res = await request<
		{
			name: string;
			key: string;
		}[]
	>({
		url: `/base/system/sysCatDic/getByTypeKey`,
		method: 'post',
		params: {
			typeKey,
		},
	});
	const resp: {
		label: string;
		value: string;
	}[] = res.map((p) => ({
		label: p.name,
		value: p.key,
		...p,
	}));
	return resp;
}

export async function findTreeDataWithNoRoot() {
	const res = await request<any>({
		url: '/base/system/sysCatType/findTreeDataWithNoRoot',
		type: 'get',
		params: {
			categoryKey: 'DIC_TYPE',
		},
	});
	const resp: {
		label: string;
		value: string;
	}[] = res.map((p) => ({
		label: p.name,
		value: p.typeKey,
		...p,
	}));
	return resp;
}

/**
 * 获取指定字典分类下字段列表
 */
export async function useDictList(params: { dictType: string }) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.useDictList(params);
	}
	const { dictType } = params;
	const res = await getDicts(dictType);
	return res;
}
